export const DEFAULT_USERPROFILE_PHOTO_URL = "assets/images/user.png";
// export const DEFAULT_EVENTPURCHASESUMMARY_PHOTO_URL = "assets/images/event-purchase-summary.jpg";
// export const DEFAULT_SITE_URL = "https://bidmobeta-portal.live1.dev.radixweb.net";
// export const DEFAULT_EVENTVENUECHART_PHOTO_URL = "assets/images/ticket-status-map.jpg";

